import { render, staticRenderFns } from "./Formularios.vue?vue&type=template&id=71e305d8&scoped=true"
import script from "./Formularios.vue?vue&type=script&lang=js"
export * from "./Formularios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e305d8",
  null
  
)

export default component.exports